import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import { motion } from 'framer-motion';
type Item = {
  highlight: string;
  rest: string;
  highlightColor?: string;
};
const items: Item[] = [{
  highlight: '50 productos nuevos',
  rest: ' durante el año — subidos mes a mes.',
  highlightColor: 'text-blue-600'
}, {
  highlight: 'Tendencias fijas',
  rest: ' — San Valentín, Pascua, Día del Padre, Halloween, Navidad.',
  highlightColor: 'text-blue-600'
}, {
  highlight: 'Tendencias inesperadas',
  rest: ' — el próximo Mundial, series virales, el meme del momento.',
  highlightColor: 'text-blue-600'
}, {
  highlight: 'Archivos listos para imprimir',
  rest: ' en alta calidad.',
  highlightColor: 'text-blue-600'
}, {
  highlight: 'Prioridad en soporte',
  rest: ' y pedidos personalizados.',
  highlightColor: 'text-blue-600'
}, {
  highlight: 'Mismo modelo que las cartas:',
  rest: ' imprimí barato, revendé con +75% de margen.',
  highlightColor: 'text-blue-600'
}, {
  highlight: 'PAGO ÚNICO',
  rest: ' — sin suscripción, sin mensualidades, acceso para siempre.',
  highlightColor: 'text-red-600'
}];
export function ValueStack() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="bg-slate-50 rounded-2xl p-6 md:p-8 border border-slate-100" data-id="element-53">
      <h3 className="text-2xl font-bold text-slate-900 mb-2 text-center" data-id="element-54">
        Esto es lo que te llevás:
      </h3>
      <p className="text-center text-slate-500 text-sm mb-6" data-id="element-55">
        Acceso total al Proveedor de Tendencias
      </p>

      <ul className="space-y-4 border-l-4 border-blue-500 pl-5" data-id="element-56">
        {items.map((item, index) => <motion.li key={index} initial={{
        opacity: 0,
        x: -10
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.08
      }} className="flex items-start gap-3" data-id="element-57">
            <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0 mt-1" data-id="element-58" />
            <p className="text-slate-800 text-base md:text-lg leading-snug" data-id="element-59">
              <span className={`font-bold ${item.highlightColor}`} data-id="element-60">
                {item.highlight}
              </span>
              <span data-id="element-61">{item.rest}</span>
            </p>
          </motion.li>)}
      </ul>

      {/* Callout: explica por qué este precio es más bajo */}
      <div className="mt-8 bg-amber-50 border-2 border-amber-300 rounded-xl p-5" data-id="element-62">
        <div className="flex items-start gap-3 mb-3" data-id="element-63">
          <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-64" />
          <div data-id="element-65">
            <p className="text-slate-900 font-bold text-base md:text-lg leading-snug" data-id="element-66">
              <span className="line-through text-slate-400" data-id="element-67">
                BONO: Calculadora de Costos Profesional
              </span>
            </p>
            <p className="text-slate-600 text-sm mt-1" data-id="element-68">
              Este bono <strong data-id="element-69">NO está incluido</strong> en esta versión.
            </p>
          </div>
        </div>
        <div className="bg-white rounded-lg p-3 border border-amber-200" data-id="element-70">
          <p className="text-sm text-slate-700 leading-relaxed" data-id="element-71">
            <span className="font-bold text-amber-700" data-id="element-72">
              ¿Por qué sale menos?
            </span>{' '}
            Eliminamos la <strong data-id="element-73">calculadora profesional de costos</strong>{' '}
            para bajarte el precio al mínimo. Te llevás solo los{' '}
            <strong data-id="element-74">diseños y tendencias</strong> — perfecto si ya tenés tu
            propio sistema para calcular precios.
          </p>
        </div>
      </div>
    </motion.div>;
}